import { call, put, select, takeLatest } from 'redux-saga/effects';
import getProductId from '../../selectors/product';
import * as actions from './actions';
import * as api from '../../api';
import { showToast } from '../../components/toast/actions';

export function* getClassrooms() {
    const productId = yield select(getProductId);
    const payload = yield call(api.getClassrooms, productId);
    if (payload.status === 200) {
        yield put(actions.getProductClassroomsSuccess(payload, productId));
    } else {
        yield put(actions.getProductClassroomsFailure(productId));
    }
}

export function* getClassroomsSaga() {
    yield takeLatest(actions.GET_CLASSROOMS_REQUEST, getClassrooms);
}

export function* downloadClassroomStudentsSignInsCards({ selectedProductId, studentSignInCardsData }) {
    const response = yield call(api.downloadClassroomsStudentsSignInCards, {
        productId: selectedProductId,
        studentSignInCardsData
    });
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.printStudentsSignInCardSuccess(downloadUrl));
    } else {
        yield put(actions.printStudentsSignInCardFailure());
    }
}

export function* downloadClassroomStudentsSignInsCardsSaga() {
    yield takeLatest(actions.PRINT_STUDENTS_SIGN_IN_CARD_REQUEST, downloadClassroomStudentsSignInsCards);
}

export function* getProductCourses({ countryCode, productId, yearGroup }) {
    const countriesRequest = { countryCode, productId, yearGroup };
    const response = yield call(api.getProductCourses, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getProductCoursesSuccess(response.data));
    } else {
        yield put(actions.getProductCoursesFailure());
    }
}

export function* getProductCoursesSaga() {
    yield takeLatest(actions.GET_PRODUCT_COURSES_REQUEST, getProductCourses);
}

export function* addClass({ ClassModel }) {
    const response = yield call(api.addClass, ClassModel);
    if (response.status === 200) {
        yield put(actions.AddClassSuccess(response.data.userProfileId));
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.AddClassFailure(false, response.message));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.AddClassFailure(true, ''));
    }
}

export function* addClassSaga() {
    yield takeLatest(actions.ADD_CLASS_REQUEST, addClass);
}

export function* downloadClassRoll({ classrooms }) {
    const classInfo = classrooms.map(classroom => ({
        className: classroom.name,
        yearGroupShortName: classroom.yearGroupShortName,
        course: classroom.courseTitle,
        upfCourse: classroom.upfCourseTitle,
        conquestCourse: classroom.conquestCourseTitle,
        assignedTeachersName: classroom.teachers.map(teacher => teacher.name),
        studentsCount: classroom.studentsProfileId.length
    }));

    const response = yield call(api.postClassesPriorDownload, classInfo);
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.downloadClassRollSuccess(downloadUrl, true));
    } else {
        yield put(actions.downloadClassRollFailure(true));
    }
}


export function* downloadClassRollSaga() {
    yield takeLatest(actions.DOWNLOAD_CLASS_ROLL_REQUEST, downloadClassRoll);
}

export function* getSchoolCourses({ yearGroup }) {
    const request = { yearGroup };
    const response = yield call(api.getSchoolCourses, request);
    if (response.status === 200) {
        yield put(actions.getSchoolCoursesSuccess(response.data));
    } else {
        yield put(actions.getSchoolCoursesFailure());
    }
}

export function* getSchoolCoursesSaga() {
    yield takeLatest(actions.GET_SCHOOL_COURSES_REQUEST, getSchoolCourses);
}

export function* deleteClassrooms({ selectedClassroomIds }) {
    const ids = { classroomIds: selectedClassroomIds };
    const response = yield call(api.deleteClassrooms, ids);
    yield put(actions.closeDeleteClassroomsConfirmation());
    if (response.status === 200) {
        yield put(actions.openDeleteClassroomsSuccess());
        yield put(actions.deleteClassroomsSuccess(response));
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.deleteClassroomsFailure(response.message));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.deleteClassroomsFailure());
        yield put(showToast(response.message, 'error'));
    }
}

export function* deleteClassroomsSaga() {
    yield takeLatest(actions.DELETE_CLASSROOMS_REQUEST, deleteClassrooms);
}

export function* getUPFCourses({ countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses }) {
    const countriesRequest = { countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses };
    const response = yield call(api.getFilteredCourses, countriesRequest);

    if (response.status === 200) {
        yield put({
            type: actions.GET_UPF_COURSES_SUCCESS,
            data: response.data,
            isProductCoursesLoaded: true,
            isProductCoursesFetching: false
        });
    } else {
        yield put({ type: actions.GET_UPF_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });
    }
}

export function* getUPFCoursesSaga() {
    yield takeLatest(actions.GET_UPF_COURSES, getUPFCourses);
}

export function* getNewCourses({ productId }) {
    const request = { productId };
    const response = yield call(api.getConquestFilteredCourses, request);

    if (response.status === 200) {
        const sortedDataByName = [...response.data].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
        yield put({
            type: actions.GET_NEW_COURSES_SUCCESS,
            data: sortedDataByName,
            isProductCoursesLoaded: true,
            isProductCoursesFetching: false
        });
    } else {
        yield put({ type: actions.GET_NEW_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });
    }
}

export function* getNewCoursesSaga() {
    yield takeLatest(actions.GET_NEW_COURSES_REQUEST, getNewCourses);
}



// WEBPACK FOOTER //
// ./app/containers/class-roll/saga.js